

import { create } from 'zustand';

type ArchiveStatus = 'current' | 'archive' | null;

interface TempFiltersState {
  archiveStatus: ArchiveStatus;
  tags: Record<string, boolean>;
}

interface AdditionalFilterState {
 
  isOpenFilterDropdown: boolean;
  toggleDropdown: () => void;
  closeDropdown: () => void;
  openDropdown: () => void;
  

  tempFilters: TempFiltersState;
  setTempFilters: (filters: TempFiltersState) => void;
  updateTempFilters: (partialFilters: Partial<TempFiltersState>) => void;
  

  handleTempTagChange: (tagId: string) => void;
  handleTempArchiveChange: (status: ArchiveStatus) => void;
  handleClear: () => void;
}

export const useAdditionalFilterStore = create<AdditionalFilterState>(
  (set) => ({
  
    isOpenFilterDropdown: false,
    toggleDropdown: () =>
      set((state) => ({ isOpenFilterDropdown: !state.isOpenFilterDropdown })),
    closeDropdown: () => set({ isOpenFilterDropdown: false }),
    openDropdown: () => set({ isOpenFilterDropdown: true }),
    

    tempFilters: {
      archiveStatus: null,
      tags: {},
    },
    
    setTempFilters: (filters: TempFiltersState) => set({ tempFilters: filters }),
    updateTempFilters: (partialFilters: Partial<TempFiltersState>) => 
      set((state) => ({
        tempFilters: {
          ...state.tempFilters,
          ...partialFilters,
        }
      })),
    
    handleTempTagChange: (tagId: string) => 
      set((state) => ({
        tempFilters: {
          ...state.tempFilters,
          tags: {
            ...state.tempFilters.tags,
            [tagId]: !state.tempFilters.tags[tagId],
          }
        }
      })),
    
    handleTempArchiveChange: (status: ArchiveStatus) => 
      set((state) => ({
        tempFilters: {
          ...state.tempFilters,
          archiveStatus: state.tempFilters.archiveStatus === status ? null : status,
        }
      })),
    
    handleClear: () => 
      set({
        tempFilters: {
          archiveStatus: null,
          tags: {},
        }
      }),
  })
);
